/*
ABOUT >>
THIS INPUT USED FOR CALLING API FOR SOFTWARE DROPDOWN 
FULLY DYNAMIC DATASOURCES BY USING API ROUTES 

ACTIVE >>
ITS IN RUNNING POSITION

UPDATES >>
IT WILL BE UPDATE FOR CALLING API FOR LIST DATASOURCE IF DataSourceType IS Route and give parameters with this api
*/
import http from '../../services/http-common';
import securityService from '../security/security.service';

class ApiService {
    getAllForList(type,objectParams = {}) {
        let queryParams = new URLSearchParams(objectParams).toString();

    // return http.get(`/dropdownApi/${type}?${queryParams}`);
        return http.get(`/dropdownApi/${type}`);
    
}
}

export default new ApiService();